// DonutScore.jsx
import { PieChart, Pie, Cell } from "recharts";

export default function DonutScore({ value, label, color }) {
  const data = [
    { name: "value", value },
    { name: "rest", value: 100 - value }
  ];

  return (
    <div style={styles.container}>
      <PieChart width={140} height={140}>
        <Pie
          data={data}
          innerRadius={45}
          outerRadius={60}
          startAngle={90}
          endAngle={-270}
          dataKey="value"
          stroke="none"
          animationDuration={800}
        >
          <Cell fill={color} />
          <Cell fill="#e5e7eb" />
        </Pie>
      </PieChart>

      {/* CENTER TEXT */}
      <div style={styles.center}>
        <div style={styles.value}>{value}%</div>
        <div style={styles.label}>{label}</div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    position: "relative",
    width: 140,
    height: 140
  },
  center: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center"
  },
  value: {
    fontSize: 20,
    fontWeight: 700
  },
  label: {
    fontSize: 12,
    color: "#64748b"
  }
};